import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { AppContext } from "../../AppContext";
import Sidebar from "./sidebar";
import HTMLReactParser from "html-react-parser";
import { Helmet } from "react-helmet";

const BlogDetails = () => {
  const { users, sendClickStatus } = useContext(AppContext);
  const { id } = useParams();
  let publicUrl = process.env.PUBLIC_URL + "/";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const post = users.find(
    (user) =>
      (user.post_type === "post" || user.post_type === "New") &&
      user.ID.toString() === id
  );

  const image = users.find(
    (img) => img.post_type === "attachment" && img.post_parent.toString() === id
  );

  const imageUrl =
    post?.post_type === "New"
      ? "https://hondaapi.clientcoding.com/" + post?.guid
      : image
      ? image.guid
      : "https://hondaapi.clientcoding.com/assets/img/default.jpg";

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  // Feedback modal states
  const [showModal, setShowModal] = useState(false);
  const [answer, setAnswer] = useState("");
  const [email, setEmail] = useState("");
  const [feedbackSent, setFeedbackSent] = useState(false);

  const submitFeedback = async () => {
    if (!email || !answer) {
      alert("Both email and answer are required.");
      return;
    }

    const formData = new FormData();
    formData.append("email", email); // 👈 must match backend field exactly
    formData.append("answer", answer); // 👈 must match backend field exactly
    try {
      const res = await fetch(
        "https://hondaapi.clientcoding.com/api/feedback",
        {
          method: "POST",
          body: formData,
        }
      );

      if (res.ok) {
        setFeedbackSent(true);
        setShowModal(false);
        alert("Thank you for your feedback!");
      } else {
        const errText = await res.text();
        console.error("❌ Failed", res.status, errText);
        alert("Submission failed: " + res.status);
      }
    } catch (error) {
      console.error("❌ Error submitting form:", error);
      alert("Something went wrong!");
    }
  };
console.log(post,'o')

  if (!post) {
    return <p>Post not found!</p>;
  }

  return (
    <div className="blog-page-area pd-bottom-80 go-top">
      <Helmet>
        <title>{post.post_title}</title>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={post.post_title} />
        <meta property="og:image" content={imageUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.post_title} />
        <meta name="twitter:image" content={imageUrl} />
      </Helmet>

      <div className="container">
        <div className="row">
          <div className="col-lg-9 pt-3">
            <div className="blog-details-page-inner">
              <div className="single-blog-inner m-0">
                <h5 className="title mt-3 title-det">{post.post_title}</h5>

                <div className="single-post-wrap style-overlay">
                  <div className="thumb">
                    <img
                      src={imageUrl}
                      alt={post.post_title}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "550px",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-end position-absolute top-0 m-2 share-div">
                    <p className="mb-0 mr-3">शेयर करे :- </p>
                    <div className="blog-share">
                      <ul
                        className="social-area d-inline"
                        style={{
                          listStyle: "none",
                          padding: 0,
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        {/* WhatsApp */}
                        <li>
                          <a
                            className="fb"
                            style={{ background: "green" }}
                            href={`https://wa.me/?text=${encodeURIComponent(
                              post.post_title + " " + window.location.href
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                              sendClickStatus(post.ID, "share");
                            }}
                          >
                            <i
                              className="fa fa-whatsapp"
                              style={{ color: "#fff" }}
                            />
                          </a>
                        </li>

                        {/* Facebook */}
                        <li>
                          <a
                            className="fb"
                            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                              window.location.href
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                              sendClickStatus(post.ID, "share");
                            }}
                          >
                            <i
                              className="fa fa-facebook"
                              style={{ color: "#fff" }}
                            />
                          </a>
                        </li>

                        {/* Twitter / X */}
                        <li>
                          <a
                            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                              post.post_title
                            )}&url=${encodeURIComponent(window.location.href)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fbs"
                            onClick={() => {
                              sendClickStatus(post.ID, "share");
                            }}
                            style={{ background: "black" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path d="M20.39 3H16.6l-4.41 5.73L8.15 3H3l7.11 9.21L3 21h3.78l4.74-6.16L15.85 21H21l-7.31-9.5L20.39 3z" />
                            </svg>
                          </a>
                        </li>

                        {/* Telegram */}
                        <li>
                          <a
                            className="fb"
                            href={`https://t.me/share/url?url=${encodeURIComponent(
                              window.location.href
                            )}&text=${encodeURIComponent(post.post_title)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                              sendClickStatus(post.ID, "share");
                            }}
                            style={{ background: "#36aade" }}
                          >
                            <i
                              className="fa fa-telegram"
                              style={{ color: "#fff" }}
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="details pb-4">
                    <div className="post-meta-single mb-2">
                      <ul>
                        <li>
                          <a className="tag-base tag-blue" href="#">
                            {post.post_type === "New"
                              ? post.cat
                              : post.category_name}
                          </a>
                        </li>
                        <li>
                          <p className="black">
                            <i className="fa fa-clock-o" />
                            {formatDate(post.post_date_gmt)}
                          </p>
                        </li>
                        <li>
                          <i className="fa fa-user" />
                          {post.post_type === "New"
                            ? post.author
                            : post.author_name}
                        </li>
                      </ul>
                    </div>
                    <h5 className="title mt-0 title-dets">{post.post_title}</h5>
                  </div>
                  <div className="mt-0 d-flex justify-content-start">
                    <a
                      href="#"
                      style={{
                        color: "#ff2727ff", 
                        fontWeight: "bold",
                        fontSize: "18px",
                        cursor: "pointer",
                        animation: "pulseBlink 1.5s infinite",
                        display: "inline-block",
                      }}
                      onClick={() => {
                        alert("Video action here"); // Replace with modal/video scroll logic
                      }}
                    >
                      🎥 वीडियो देखें
                    </a>
                  </div>

                  <style>
                    {`
    @keyframes pulseBlink {
      0% { transform: scale(1); opacity: 1; }
      50% { transform: scale(0.8); opacity: 1; }
      100% { transform: scale(1); opacity: 1; }
    }
  `}
                  </style>
                </div>

                {/* Post content */}
                <div className="single-blog-details mt-0">
                  <div>{HTMLReactParser(post.post_content)}</div>
                </div>

                {/* Feedback question */}
                <div className="mt-4 p-3 border rounded shadow-sm">
                  <h6>Is this news relevant for you?</h6>
                  <button
                    className="btn btn-success me-2 mr-2"
                    onClick={() => {
                      setAnswer("yes");
                      setShowModal(true);
                    }}
                  >
                    Yes
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      setAnswer("no");
                      setShowModal(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <Sidebar />
        </div>
      </div>

      {/* Feedback Modal */}
      {showModal && (
        <div
          className="modal d-block"
          style={{ background: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-3">
              <div className="modal-header">
                <h5 className="modal-title">Share your Feedback</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Your answer: <strong>{answer}</strong>
                </p>
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="modal-footer ">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={submitFeedback}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogDetails;
